import { useCompany } from "../CompanyProvider/CompanyProvider";
import { replaceCompanyName } from "./footer-utils";
export const useFooter = () => {
    const { buildVersion, companyUsesSMS, displayName, footerAttributionMD } = useCompany();
    const mealTrackLink = `https://mealtrack.com/?utm_campaign=AppReferral&utm_source=MT&utm_medium=${encodeURIComponent(displayName)}`;
    const allRightsReserved = `© ${new Date().getFullYear()} ${displayName} All rights reserved`;
    const replacedFooter = replaceCompanyName(footerAttributionMD, displayName);
    return {
        allRightsReserved,
        buildVersion,
        companyUsesSMS,
        mealTrackLink,
        replacedFooter,
    };
};
